export const joinWithSeparator = (values: Array<string | number | null | undefined>): string => {
  const filteredValues = values.filter(
    (value) => value !== null && value !== undefined && value !== '',
  );
  return filteredValues.join(' · ') || '';
};
